import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import Loader from '@amzn/meridian/loader';
import Masthead, { MastheadMenuButton, MastheadTitle } from '@amzn/meridian/masthead';
import signOutTokens from '@amzn/meridian-tokens/base/icon/sign-out';
import userTokens from '@amzn/meridian-tokens/base/icon/user';
import { useGetBusinessCategoriesQuery } from '@amzn/rangoli-seller-desktop-api-utils/src/index';
import { useLogoutUserMutation } from '@amzn/rangoli-seller-desktop-fe-auth-utils/src/index';
import { PathName } from '@amzn/rangoli-seller-desktop-utils/src/index';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import googlePlayButton from '../../assets/googlePlayButton.svg';
import securityIcon from '../../assets/help.svg';
import smartBizLogo from '../../assets/logo.svg';
import ProfileMenuMobile from '../../components/ProfileMenu/ProfileMenuMobile';
import Sidebar from '../../components/Sidebar/Sidebar';
import { redirectionUrls } from '../../constants/apiConstants';
import { HeaderType, ImageAlternatives } from '../../constants/mainHeaderConstant';
import { helpAndSupportStore } from '../../store/HelpAndSupportStore';
import { sidebarStore } from '../../store/SidebarStore';
import { userAuthStore } from '../../store/UserAuthStore';
import { heightStyle, signOutIconStyle } from '../../Style/Style';
import { IMainHeaderProps } from '../../types/MainHeaderTypes';

const { SECONDARY_HEADER } = HeaderType;
const { SMARTBIZ, GOOGLE_PLAY, SECURITY } = ImageAlternatives;
const HOME = PathName['HOME'];

const MainHeaderMobile = ({ mode }: IMainHeaderProps) => {
  const navigate = useNavigate();
  const logoutUserMutation = useLogoutUserMutation();
  const { isLoading } = logoutUserMutation;
  const { isProfileDetailsActive, handleChangeActiveProfileDetails } = helpAndSupportStore;
  const { setSidebarToggle } = sidebarStore;
  const { setHelpMenuToggle } = helpAndSupportStore;
  const {
    data: CategoriesList,
    isLoading: isCategoryLoading,
    error: categoriesError,
  } = useGetBusinessCategoriesQuery();
  const isCategoryError: boolean = categoriesError ? true : false;

  const handleLogoutUser = async (): Promise<void> => {
    const res = await logoutUserMutation.mutateAsync();
    userAuthStore.isLoggedOut();
    window.location.replace(res?.redirectUrl);
  };

  const hanldeGooglePlayNavigation = (): void => {
    window.location.replace(redirectionUrls.sellerAppGooglePlayStore);
  };

  return (
    <>
      <Masthead size="medium">
        {mode !== SECONDARY_HEADER && <MastheadMenuButton onClick={setSidebarToggle} open={true} />}
        <MastheadTitle onClick={() => navigate(HOME)}>
          <img src={smartBizLogo} alt={SMARTBIZ} width="74px" />
        </MastheadTitle>
        {mode === SECONDARY_HEADER && (
          <Button onClick={hanldeGooglePlayNavigation} type="icon">
            <img src={googlePlayButton} width="80px" height="35px" alt={GOOGLE_PLAY} />
          </Button>
        )}
        {mode === SECONDARY_HEADER ? (
          <Button
            onClick={handleLogoutUser}
            size="small"
            type="icon"
            minWidth="36px"
            className={heightStyle}
          >
            {isLoading ? (
              <Loader size="small" />
            ) : (
              <Icon tokens={signOutTokens} className={signOutIconStyle} />
            )}
          </Button>
        ) : (
          <>
            <Button onClick={setHelpMenuToggle} type="icon">
              <img src={securityIcon} alt={SECURITY} />
            </Button>
            <Button
              type="icon"
              size="small"
              onClick={() => handleChangeActiveProfileDetails(!isProfileDetailsActive)}
            >
              <Icon tokens={userTokens} />
            </Button>
          </>
        )}
      </Masthead>
      <Sidebar showMobileView={true} />
      <ProfileMenuMobile
        isLoading={isCategoryLoading}
        CategoriesList={CategoriesList?.categories}
        isCategoryError={isCategoryError}
      />
    </>
  );
};

export default observer(MainHeaderMobile);
